import { styled } from '@mui/material';

export const Checkboxes = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
}));
